import { useEffect } from 'react';

import { useAuthStore } from '@modules/auth/store';
import { PartnerOrganization } from '@modules/core/types/partnerType.type';
import useOrganizationName from '@modules/my-account/hooks/useOrganizationName';
import { Permissions, UsePermissionsValue } from '@modules/permissions/types';
import { getPermissionsByUser } from '@modules/permissions/utils';

const usePermissions = (): UsePermissionsValue => {
  const organizationName = useOrganizationName();
  const { user: currentUser, partner, updatePartner, permissions, updatePermissions } = useAuthStore();

  useEffect(() => {
    if (!currentUser) {
      return;
    }

    const updatedPartner: string | PartnerOrganization = import.meta.env.DEV ? partner ?? '' : organizationName ?? '';
    updatedPartner && updatePartner(updatedPartner as PartnerOrganization);
  }, [organizationName, currentUser, partner]);

  useEffect(() => {
    if (!currentUser || !partner) {
      return;
    }

    updatePermissions(getPermissionsByUser(currentUser, partner));
  }, [partner]);

  /** ONLY FOR DEV PURPOSES */
  const setPartnerOrganization = (): void => {
    // if dev environment, then checks for existing partner overriden by dev tool
    if (import.meta.env.DEV) {
      let updatedPartner: string | PartnerOrganization = organizationName ?? '';
      updatedPartner = organizationName ?? '';
      updatePartner(updatedPartner as PartnerOrganization);
    }
  };

  const hasPermission = (permission: Permissions): boolean => {
    if (!currentUser || !partner) return false;
    return permissions.includes(permission);
  };

  return {
    hasPermission,
    setPartnerOrganization,
  };
};

export default usePermissions;
